import { SW_DRAW_ARRIVE_INDEX, SW_DRAW_BEATS } from "../lib/beats";
import WalkIn from "../components/WalkIn";

/** Stageward, second leg: out of the coat closet, up to the Drawing Table. */
export default function DrawingWalk() {
  return (
    <WalkIn
      beats={SW_DRAW_BEATS}
      realm="stageward"
      pathPrefix="/stageward/drawing"
      arriveIndex={SW_DRAW_ARRIVE_INDEX}
      arriveTo="/stageward/table"
      arriveLabel="Lay them out"
      skipLabel="Straight to the table"
      placeName="The Drawing Room"
      choiceLine="Carry it through yourself, or let MelzAI walk you up?"
    />
  );
}
